import { debounce, iOS } from './helpers';

jQuery(function ($) {
  const $fullbleedLeft = $('.fullbleed__left');
  const $fullbleedRight = $('.fullbleed__right');
  const inLayoutBuilder = $fullbleedLeft.hasClass('layout-builder__region');

  if (inLayoutBuilder || !$fullbleedLeft.length) {
    // Nothing to do
    return;
  }

  // Update to sticky position once the DOM loads
  $fullbleedLeft.addClass('fullbleed__left--sticky');

  // Lookup things that don't change
  const $imageRows = $('.fullbleed-container .views-row');
  const fullbleedScrollProgress = $('.fullbleed-scroll-progress').get(0);
  const $topNav = $('.top-nav');
  const $subNav = $('.subnav--ep .subnav__title, .subnav--blog .subnav__title');
  const $pageBotton = $('#page-bottom');
  const $localTasks = $('.subnav--local-tasks');
  const $patientToolsToggle = $('.patient-tools-toggle');

  // These values change often so only allocate them once
  let isMobile = $(window).width() < 1200;
  let topNavBottom = 0;
  let navBottom = 0;
  let localTasksBottom = 0;
  let localTasksHeight = 0;
  let subNavBottom = 0;
  let subNavHeight = 0;
  let patientToolsHeight = 0;
  let activeIndex = 0;

  function imageLoaded() {
    $(this).closest('.views-row').addClass('loaded');
  }

  const updateActive = debounce(() => {
    const $image = $('.media--fullbleed img', $imageRows.get(activeIndex));

    // Track if image is loaded and ignore incomplete
    $image.off('load', imageLoaded);
    if ($image.get(0).complete) {
      imageLoaded.bind($image.get(0))();
    } else {
      $image.on('load', imageLoaded);

      return;
    }

    // Swap images
    $('.fullbleed-images').removeClass('uninitialized');
    $imageRows.removeClass('show');
    $($imageRows.get(activeIndex)).addClass('show');
  }, 100);

  const recalculatePositions = function () {
    isMobile = $(window).width() < 1200;

    topNavBottom = $topNav.length && Math.round($topNav[0].getBoundingClientRect().bottom);
    pageBottom = $pageBotton.length && $pageBotton[0].getBoundingClientRect().top;
    if ($localTasks.length) {
      const rect = $localTasks[0].getBoundingClientRect();
      localTasksBottom = rect.bottom;
      localTasksHeight = rect.height;
    }
    if ($subNav.length) {
      const rect = $subNav[0].getBoundingClientRect();
      subNavBottom = rect.bottom;
      subNavHeight = rect.height;
    }
    navBottom = Math.max(localTasksBottom, subNavBottom, topNavBottom);

    if ($patientToolsToggle.length && $(window).width() < 768) {
      patientToolsHeight = $patientToolsToggle[0].getBoundingClientRect().height;
    } else {
      patientToolsHeight = 0;
    }

    const scrollTop = $(window).scrollTop();
    const height = $('.fullbleed').height();
    // const visibleHeight = height - scrollTop + subNavHeight + localTasksHeight;
    const fullbleedHeight = $fullbleedLeft.height();
    const scrollableHeight = Math.max(
      100, // Minimum scroll height to ensure all images are seen.
      height - fullbleedHeight + subNavHeight + localTasksHeight,
    );
    const scrollPercent = Math.min(1, scrollTop / scrollableHeight);

    fullbleedScrollProgress.style.setProperty('--scroll-progress', `${scrollPercent * 100}%`);

    // Handle fullbleed positioning when content scrolls
    $fullbleedLeft.css('top', `${topNavBottom}px`);
    $fullbleedRight[0].style.marginTop = `-${fullbleedHeight}px`;

    if (isMobile || $imageRows.length < 2) {
      // No need to compute active image
      return;
    }

    /** Determine active fullbleed image on desktop */
    const contentBottom = $(
      '.block-views-blockextraordinary-people-block-ep-detail-rest-content-blocks, .block-views-blockdear-donor-block-dear-donor-detail-rest-content-blocks'
    )[0].getBoundingClientRect().bottom;

    const centerIndicator = window.innerHeight * 0.6;

    const firstBlock = $('.ep-dd-components').get(0);
    const firstBlockCenter = Math.min(
      centerIndicator,
      navBottom + firstBlock.offsetTop + firstBlock.clientHeight / 2,
    );

    const lastBlock = $('.ep-dd-components').get(-1);
    const lastBlockCenter = Math.max(
      centerIndicator,
      Math.min(contentBottom, window.innerHeight) - lastBlock.clientHeight / 2,
    );

    // Interpolate scroll indicator between top and bottom bounds as you scroll
    const scrollIndicator = firstBlockCenter + (lastBlockCenter - firstBlockCenter) * scrollPercent;

    // Find content block that should be active based on scrollIndicator
    let tmpIndex = 0;
    $('.ep-dd-components').each((index, element) => {
      if (element.getBoundingClientRect().top > scrollIndicator) {
        // Returning false causes $.each to exit loop
        return false;
      }
      tmpIndex = index;
    });

    // Update active index if it changed
    if (tmpIndex !== activeIndex) {
      activeIndex = tmpIndex;
      updateActive();
    }
  };

  const recalculateHeights = function () {
    // Changes based on mobile browser nav
    const navAwareWindowHeight = window.innerHeight;
    // Ignores mobile browser nav
    const staticWindowHeight = $(window).height();

    if (isMobile) {
      // Use values that don't change with mobile browser nav
      const navHeights = subNavHeight + localTasksHeight + patientToolsHeight;
      const availableHeight = staticWindowHeight - (topNavBottom + navHeights);

      $('.fullbleed-scroll-progress').css('height', '');
      $('.fullbleed__right').css('min-height', '');

      const $headerWithImg = $('.fullbleed__header:not(.header--no-image)');
      $headerWithImg.css('min-height', `${Math.max(availableHeight, 450)}px`);

      const $mtrBG = $('.mtr__bg--mobile .content-making-the-rounds__content');
      if ($mtrBG.length) {
        const mtrHeight = $mtrBG[0].clientHeight + 120;

        if (mtrHeight <= availableHeight) {
          $headerWithImg.css('height', '1px');
        } else {
          $headerWithImg.css('height', '');
        }
      }
    } else {
      // Desktop
      $(
        '.fullbleed-container, ' +
          '.fullbleed-scroll-progress, ' +
          '.media--fullbleed:not(.media--sensitive) > img, ' +
          '.content-making-the-rounds__container',
      ).css('height', `calc(${navAwareWindowHeight - topNavBottom}px`);

      $('.media--sensitive > img').css(
        'height',
        `calc(${navAwareWindowHeight - topNavBottom + 80}px`,
      );

      $('.fullbleed__right').css('min-height', `calc(${navAwareWindowHeight - topNavBottom}px`);
      $('.fullbleed__header').css('min-height', '');
      $('.fullbleed__header').css('height', '');
    }
  };

  $('.sensitive-overlay .btn').click(function () {
    $(this).closest('.media--sensitive').removeClass('media--sensitive');
    recalculateHeights();
  });

  // Recalculate position on both scroll / resize
  new ResizeObserver(recalculatePositions).observe($('html')[0]);
  $(window).on('scroll resize', recalculatePositions);
  recalculatePositions();

  // Recalculate heights only on resize
  new ResizeObserver(recalculateHeights).observe($('html')[0]);
  $(window).on('resize', recalculateHeights);
  recalculateHeights();

  if (iOS()) {
    // On iOS, the values calculated for the navigation positions are incorrect when the DOM
    // initially loads. This hack attempts to recalculate every frame for the first 3 seconds.
    let start = null;
    const iosHack = (now) => {
      if (start == null) {
        start = now;
      }

      if (now - start > 3000) {
        return;
      }

      recalculatePositions();
      recalculateHeights();

      requestAnimationFrame(iosHack);
    };
    requestAnimationFrame(iosHack);
  }
});
